<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBDeliveryList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBDeliveryForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBDeliveryForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBDeliveryForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbdelivery/update/isLoading',
      error: 'exsbdelivery/update/error',
      deleteError: 'exsbdelivery/del/error',
      deleteLoading: 'exsbdelivery/del/isLoading',
      created: 'exsbdelivery/create/created',
      deleted: 'exsbdelivery/del/deleted',
      retrieved: 'exsbdelivery/update/retrieved',
      updated: 'exsbdelivery/update/updated',
      violations: 'exsbdelivery/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBDeliveryList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBDeliveryUpdate')
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbdelivery/create/reset',
      deleteItem: 'exsbdelivery/del/del',
      delReset: 'exsbdelivery/del/reset',
      retrieve: 'exsbdelivery/update/retrieve',
      updateReset: 'exsbdelivery/update/reset',
      update: 'exsbdelivery/update/update',
      updateRetrieved: 'exsbdelivery/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbdelivery ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
